import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { RuleSet } from 'ngx-angular-query-builder';

@Injectable()
export class DashboardWidgetFilterService {

  constructor(private readonly http: HttpClient, private readonly urlBuilder: UrlBuilderService) { }

  saveFilter(dashboardWidgetId: string, filter: RuleSet): Observable<boolean> {
    const url = this.urlBuilder.getUrl('dashboardwidget/filter');
    return this.http
      .post(url, { DashboardWidgetId: dashboardWidgetId, Filter: filter }).pipe(
        map(() => true)
      );
  }

  loadFilter(dashboardWidgetId: string): Observable<RuleSet> {
    const url = this.urlBuilder.getUrl('dashboardwidget/filter');
    const params = new HttpParams().set('dashboardWidgetId', dashboardWidgetId);
    return this.http
      .get<RuleSet>(url, { params: params });
  }

}
